/**
 * @generated SignedSource<<a77295987dae2cd63e14df0aa283f2b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentInstallmentRow_paymentSubscriptionInstallment$data = {
  readonly dateGenerateCharge: string | null | undefined;
  readonly installmentNumber: number | null | undefined;
  readonly status: string | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentInstallmentRow_paymentSubscriptionInstallment";
};
export type PaymentInstallmentRow_paymentSubscriptionInstallment$key = {
  readonly " $data"?: PaymentInstallmentRow_paymentSubscriptionInstallment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallmentRow_paymentSubscriptionInstallment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentInstallmentRow_paymentSubscriptionInstallment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "installmentNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateGenerateCharge",
      "storageKey": null
    }
  ],
  "type": "PaymentSubscriptionInstallment",
  "abstractKey": null
};

(node as any).hash = "d62e4189b3b0feb26f9f0c9d17935d4e";

export default node;
